import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { StateUtils } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { TrackingPickup } from '@tracking/const';
import { TrackingPickupService } from '@tracking/feature';
import { Observable, Subscription, filter, map, take } from 'rxjs';
import { TrackingPickupSchemeComponent } from './tracking-pickup-scheme/tracking-pickup-scheme.component';

@Component({
  selector: 'sd-tracking-pickup',
  templateUrl: './tracking-pickup.component.html',
  styleUrls: ['./tracking-pickup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TrackingPickupComponent implements OnInit, OnDestroy {
  trackingState$: Observable<StateUtils.LoaderState<TrackingPickup>>;
  showCallMessage$: Observable<boolean>;
  subscription = new Subscription();

  constructor(
    private trackingPickupService: TrackingPickupService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.trackingPickupService.loadByQueryParams();
    this.trackingState$ = this.trackingPickupService.getTrackingStateByQueryParams();

    this.showCallMessage$ = this.trackingState$.pipe(
      map((res) => {
        const statuses = res.value?.statuses || [];
        // так как статус Выдан всегда будет последним, нам нужно проверять, чтобы статус Скоро начнем собирать был не последним, а предпоследним
        const lastStatus = statuses[statuses.length - 2];
        const isFinalStatusCompleted = !!statuses[statuses.length - 1]?.formattedDateTime;

        return lastStatus?.name === 'Скоро начнем собирать' && !isFinalStatusCompleted;
      }),
    );
  }

  openScheme(): void {
    this.subscription.add(
      this.trackingState$
        .pipe(
          map((tracking) => tracking.value),
          filter((tracking): tracking is TrackingPickup => Boolean(tracking)),
          take(1),
        )
        .subscribe((tracking) => {
          const modalRef = this.modalService.open(TrackingPickupSchemeComponent, {
            centered: true,
            size: 'xl',
            windowClass: 'pickup-tracking-scheme',
          });
          modalRef.componentInstance.scheme = tracking.scheme;
          modalRef.componentInstance.orderEntries = tracking.orderEntries;
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
